import React, { Component } from 'react';
import { observer } from 'mobx-react';

// Import from Style
import {
  Wrapper
} from './style';

import TrendingSearchTerm from '../TrendingSearchTerm';

import TrendingSearchState from '../../states/TrendingSearchState';

class TrendingSearchCloud extends Component {
  componentDidMount() {
    for (let i = 0; i < TrendingSearchState.maxTagsCount; i++) {
      setTimeout(() => {
        TrendingSearchState.initItem();   
      }, 800 * i);   
    }
  }

  render() {
    const { items } = TrendingSearchState;

    return (
      <Wrapper
        style={{
          height: TrendingSearchState.height,
          margin: `-${TrendingSearchState.height/2}px -${TrendingSearchState.width/2}px`,
          width: TrendingSearchState.width,
        }}
      >
        {items.map((item, i) => (
          <TrendingSearchTerm key={item.key} item={item} exitedCallback={this.exitedCallback} />
        ))}
      </Wrapper>
    );
  }

}

export default observer(TrendingSearchCloud);



// WEBPACK FOOTER //
// ./src/components/TrendingSearchCloud/index.js